//@see https://kazupon.github.io/vue-i18n/guide/datetime.html
const defaultDateTimeFormat = {
    short: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }
}

export default {
    'de': defaultDateTimeFormat,
    'en-GB': defaultDateTimeFormat,
    'pl': defaultDateTimeFormat,
    'fr': defaultDateTimeFormat,
    'cs': defaultDateTimeFormat,
    'nl': defaultDateTimeFormat,
    'it': defaultDateTimeFormat,
    'pt': defaultDateTimeFormat,
    'es': defaultDateTimeFormat,
    'hu': defaultDateTimeFormat,
    'sk': defaultDateTimeFormat,
    'ro': defaultDateTimeFormat,
    'tr': defaultDateTimeFormat
}
